<form [formGroup]="parentFormGroup">
  <div class="versions-control">
    <mat-form-field appearance="fill" class="versions-input">
      <mat-label>Version</mat-label>
      <input matInput [formControl]="versionInputControl" autocomplete="off" (matChipInputTokenEnd)="addChip($event)"
        [matChipInputFor]="chipList">
      </mat-form-field>
      <div class="chips">
        @if (!!parentFormGroup.get(controlName).value?.length) {
          <div class="chips-legend">Selected versions: </div>
        }
        <mat-chip-grid #chipList [formControlName]="controlName" >
          @for (chip of parentFormGroup.get(controlName).value; track $index) {
            <mat-chip-row [removable]="true"
              (removed)="removeChip(chip)">
              {{ chip }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip-row>
          }
        </mat-chip-grid>
      </div>
    </div>
  </form>
